import { useSpring, animated } from '@react-spring/web';

function Divider({
  isBody = false,
  className,
  delay = 0,
  duration = 0,
}: {
  isBody?: boolean;
  className?: string;
  delay?: number;
  duration?: number;
}) {
  const styles = useSpring({
    from: { width: '0%' },
    delay,
    to: { width: '100%' },
    config: { duration },
  });

  return (
    <animated.div
      className={`ShDivider ${isBody ? 'isShBody my-sh-60' : 'my-sh-30'} h-[1px] w-full border-b border-primary-800 ${className}`}
      style={styles}
    />
  );
}

export default Divider;
